import React from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Users } from "assets/img/svg/vendorUsers.svg";
import { ReactComponent as HandCoins } from "assets/img/svg/handcoins.svg";
import { ReactComponent as Sealcheck } from "assets/img/svg/sealcheck.svg";
import { ReactComponent as Wrench } from "assets/img/svg/wrench.svg";

import { getScreenCards } from "../../finOps/IssueStock/search/SearchCard";
import { useGetPermissions } from "layouts/customHook";

const VendorCards = () => {
  const history = useHistory();
  // const userPermissions = useGetPermissions("vendorManagement");
  const approvalConfigPermissions = useGetPermissions("vendorApprovalConfig");
  const raisePaymentRequestPermissions = useGetPermissions(
    "vendorPaymentRequest",
  );
  const vendorPaymentApprovalPermissions = useGetPermissions(
    "vendorPaymentApproval",
  );
  const examPayrateMasterPermissions = useGetPermissions("examPayRateMaster");
  const vendorDashboardPermissions = useGetPermissions("vendorDashboard");
  const paymentSlabPermissions = useGetPermissions("paymentSlabMaster");
  const vendorCreationApprovalPermissions = useGetPermissions(
    "vendorCreationApproval",
  );

  const cards = [
    ...(vendorDashboardPermissions
      ? [
          {
            heading: "Vendor dashboard",
            subHeading: "View information of created vendors",
            icon: <Users />,
            action: () => history.push("/admin/vendorsList"),
            disabled: false,
          },
        ]
      : []),
    ...(raisePaymentRequestPermissions
      ? [
          {
            heading: "Vendor payment request",
            subHeading: "Raise admission advisor payments requests",
            action: () => history.push("/admin/raiseVendorRequest"),
            icon: <HandCoins />,
            //   action: ,
            disabled: false,
          },
        ]
      : []),

    ...(vendorPaymentApprovalPermissions
      ? [
          {
            heading: "Vendor payment approvals",
            subHeading: "Manage approval requests for all vendors",
            icon: <Sealcheck />,
            action: () => history.push("/admin/vendorSetup/paymentApprovals"),
            disabled: false,
          },
        ]
      : []),

    ...(vendorCreationApprovalPermissions
      ? [
          {
            heading: "Vendor creation approvals",
            subHeading: "Approve/reject creation requests for all vendors",
            icon: <Sealcheck />,
            action: () => history.push("/admin/vendorSetup/creationApprovals"),
            disabled: false,
          },
        ]
      : []),

    ...(approvalConfigPermissions
      ? [
          {
            heading: "Vendors approval config",
            subHeading: "Setup & modify roles and access",
            icon: <Wrench />,
            action: () =>
              history.push("/admin/vendorSetup/vendorApprovalConfigs"),
            disabled: false,
          },
        ]
      : []),
    ...(paymentSlabPermissions
      ? [
          {
            heading: "Payment slabs master",
            subHeading:
              "Set-up and modify payments slabs for Admission Advisors.",
            icon: <Wrench />,
            action: () => history.push("/admin/vendorSetup/paymentSlabs"),
            disabled: false,
          },
        ]
      : []),
    ...(examPayrateMasterPermissions
      ? [
          {
            heading: "Exam Pay Rate Master",
            subHeading: "Setup per hour rate for exams",
            icon: <HandCoins />,
            action: () =>
              history.push("/admin/vendorSetup/invigilatorPayrateSlabs"),
            disabled: false,
          },
        ]
      : []),
  ];

  return getScreenCards(cards);
};

export default VendorCards;
